/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const JobType = {
    CalculateTuition: 'CalculateTuition',
    TuitionPayment: 'TuitionPayment',
    ApproveAppointmentBooking: 'ApproveAppointmentBooking',
    Maintenance: 'Maintenance',
    CalculateSessions: 'CalculateSessions',
    PaymentProcessing: 'PaymentProcessing'
} as const;
export type JobType = typeof JobType[keyof typeof JobType];


export function instanceOfJobType(value: any): boolean {
    for (const key in JobType) {
        if (Object.prototype.hasOwnProperty.call(JobType, key)) {
            if (JobType[key as keyof typeof JobType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function JobTypeFromJSON(json: any): JobType {
    return JobTypeFromJSONTyped(json, false);
}

export function JobTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobType {
    return json as JobType;
}

export function JobTypeToJSON(value?: JobType | null): any {
    return value as any;
}

export function JobTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): JobType {
    return value as JobType;
}

